import loadable from '@loadable/component'
import crossRoomPk from './crossRoomPk'
import feedback from './feedback'
import giftWall from './giftWall'
import Helping from './Helping'
import loginQuestion from './loginQuestion'
import lord from './lord'
import medal from './medal'
import redEnvelope from './redEnvelope'
import SongRoomPk from './SongRoomPk'
import vip from './vip'
import wealthLevel from './wealthLevel'

export default [
  {
    path: '/code/SongRoomSingerRankList',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SongRoomSingerRankList" */ '~/pages/r_code/SongRoomTask/RankList'
        )
    ),
  },
  {
    path: '/code/SnatchSingPlay',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SnatchSingPlay" */ '~/pages/r_code/SnatchSingPlay'
        )
    ),
  },
  {
    path: '/code/PersonalDressUp',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-PersonalDressUp" */ '~/pages/r_code/PersonalDressUp'
        )
    ),
  },
  ...crossRoomPk,
  ...feedback,
  ...giftWall,
  ...Helping,
  ...loginQuestion,
  ...lord,
  ...medal,
  ...redEnvelope,
  ...SongRoomPk,
  ...vip,
  ...wealthLevel,
]
